export const ROUTES = {
  home: () => '/',
  login: () => '/login',
  legal: () => '/legal',

  // Оплата
  paymentSuccess: () => '/payment-success',
  paymentFail: () => '/payment-fail',

  // Рестораны
  restaurants: () => '/restaurants',
  restaurant: (code: string) => `/restaurants/${code}`,

  // Заказы
  orders: () => '/orders',
  orderDetail: (orderId: string | number) => `/orders/${orderId}`,
  
  // Авторизация Яндекс
  yandexCallback: () => '/auth/yandex-callback',
} as const;
